import { useState } from 'react';
import { Stack, Select, Text, Box, Divider } from '@mantine/core';
import CompanyDocumentsSandbox from './company-documents-sandbox/CompanyDocumentsSandbox';
import ConnectedAssetsSandbox from './connected-assets-sandbox/ConnectedAssetsSandbox';
import EmailSandbox from './email-sandbox/EmailSandbox';
import TipSandbox from './tip-sandbox/TipSandbox';

const SANDBOX_COMPONENTS = [
  { value: 'company-documents', label: 'Company Documents' },
  { value: 'connected-assets', label: 'Connected products' },
  { value: 'email', label: 'Email' },
  { value: 'tip', label: 'Tip' },
] as const;

type SandboxComponentValue = (typeof SANDBOX_COMPONENTS)[number]['value'];

export default function SandboxTab() {
  const [selected, setSelected] = useState<SandboxComponentValue | null>(null);

  const renderComponent = () => {
    switch (selected) {
      case 'company-documents':
        return <CompanyDocumentsSandbox />;
      case 'connected-assets':
        return <ConnectedAssetsSandbox />;
      case 'email':
        return <EmailSandbox />;
      case 'tip':
        return <TipSandbox />;
      default:
        return (
          <Text c="dimmed" ta="center" mt="xl">
            Select a component to view its sandbox demo
          </Text>
        );
    }
  };

  return (
    <Stack p="md">
      <Text size="xl" fw={700}>
        Component Sandbox
      </Text>
      <Text c="dimmed">Test and demo various components</Text>

      <Select
        label="Select component"
        placeholder="Choose a component..."
        data={SANDBOX_COMPONENTS}
        value={selected}
        onChange={value => setSelected(value as SandboxComponentValue)}
        clearable
        w={300}
      />

      <Divider />

      <Box style={{ fontFamily: 'var(--mantine-font-family)', whiteSpace: 'normal' }}>
        {renderComponent()}
      </Box>
    </Stack>
  );
}
